export const dateDiffInHours = (date1: Date, date2?: Date) => {
    let dateToCompare = date2 || new Date();
    const diff = (dateToCompare.getTime() - date1.getTime()) / 1000;
    const hours = Math.round(Math.abs(diff / 3600))
    return hours;
};
